export type SubmissionPhase =
  | 'sending'
  | 'ack_unknown'
  | 'reconciling'
  | 'accepted'
  | 'rejected';

export type SubmissionRecord = {
  clientRequestId: string;
  phase: SubmissionPhase;
  genId?: string;
  code?: string;
};

export type SubmissionState = Record<string, SubmissionRecord>;

export type SubmissionAction =
  | { type: 'sending'; clientRequestId: string }
  | { type: 'ack_unknown'; clientRequestId: string }
  | { type: 'reconciling'; clientRequestId: string }
  | { type: 'accepted'; clientRequestId: string; genId: string }
  | { type: 'rejected'; clientRequestId: string; code: string }
  | { type: 'forget'; clientRequestId: string };

export function submissionReducer(
  state: SubmissionState,
  action: SubmissionAction,
): SubmissionState {
  if (action.type === 'forget') {
    const next = { ...state };
    delete next[action.clientRequestId];
    return next;
  }
  const current = state[action.clientRequestId];
  if (current?.phase === 'accepted' || current?.phase === 'rejected') return state;
  return {
    ...state,
    [action.clientRequestId]: {
      clientRequestId: action.clientRequestId,
      phase: action.type,
      ...(action.type === 'accepted' ? { genId: action.genId } : {}),
      ...(action.type === 'rejected' ? { code: action.code } : {}),
    },
  };
}
